import { environment } from './../../environments/environment';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Proposal } from './../entities/proposal';
import { tap, catchError } from 'rxjs/operators';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ProposalService {

  @Output() proposalVoteChanged: EventEmitter<boolean> = new EventEmitter();
  @Output() proposalDeleted: EventEmitter<boolean> = new EventEmitter();


  constructor(private http: HttpClient) { }

  private baseUrl = environment.apiUrl + '/api/proposal/';
  basic: string | string[];

  getProposal(proposalId: number): Observable<any> {
      return this.http.get<Proposal[]>(this.baseUrl + `${ proposalId }`);
  }

  getOpenSpaceProposals(openSpaceId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}openspaces/${ openSpaceId }`, { responseType: 'text' });
  }

  addProposal(proposal: Proposal): Observable<Proposal> {
    return this.http.post<Proposal>(this.baseUrl, proposal);
  }

  updateProposal(proposal: Proposal, proposalId: number): Observable<any> {
    return this.http.put<Proposal>(`${this.baseUrl} ${ proposalId }`, proposal , httpOptions)
      .pipe(
      catchError(this.handleError<any>('updateProposal'))
    );
  }

  deleteProposal(proposalId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl} ${ proposalId }`)
      .pipe(
        tap(_ => this.proposalDeleted.emit(true)),
        catchError(this.handleError<any>('deleteProposal'))
    );
  }

  voteProposal(proposalId: number): Observable<any> {
    return this.http.post<Proposal>(this.baseUrl + proposalId + '/vote', {}, httpOptions)
      .pipe(
      tap(_ => this.proposalVoteChanged.emit(true)),
      catchError(this.handleError<any>('addOpen'))
    );
  }

  unvoteProposal(proposalId: number): Observable<any> {
    return this.http.post<Proposal>(this.baseUrl + proposalId + '/unvote', {}, httpOptions)
    .pipe(
      tap(_ => this.proposalVoteChanged.emit(true)),
      catchError(this.handleError<any>('addProposal'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
